var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwoSquares(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24756 5.99922C1.24756 5.21666 1.88195 4.58228 2.6645 4.58228H5.33228C5.74649 4.58228 6.08228 4.91806 6.08228 5.33228C6.08228 5.74649 5.74649 6.08228 5.33228 6.08228H2.74756V13.2526H9.91784V10.6678C9.91784 10.2536 10.2536 9.91783 10.6678 9.91783C11.082 9.91783 11.4178 10.2536 11.4178 10.6678V13.3356C11.4178 14.1182 10.7834 14.7526 10.0009 14.7526H2.6645C1.88195 14.7526 1.24756 14.1182 1.24756 13.3356V5.99922Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58252 2.99756C4.58252 2.03106 5.36602 1.24756 6.33252 1.24756H13.0028C13.9693 1.24756 14.7528 2.03106 14.7528 2.99756V9.66784C14.7528 10.6343 13.9693 11.4178 13.0028 11.4178H6.33252C5.36602 11.4178 4.58252 10.6343 4.58252 9.66784V2.99756ZM6.33252 2.74756C6.19445 2.74756 6.08252 2.85949 6.08252 2.99756V9.66784C6.08252 9.80591 6.19445 9.91784 6.33252 9.91784H13.0028C13.1409 9.91784 13.2528 9.80591 13.2528 9.66784V2.99756C13.2528 2.85949 13.1409 2.74756 13.0028 2.74756H6.33252Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwoSquares);
export default __webpack_public_path__ + "static/media/icon-two-squares.c8a9efae1a85238c6ee06e5a4877ba96.svg";
export { ForwardRef as ReactComponent };